import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Badge, Button, ButtonGroup, Table } from "reactstrap";

import { IoAdd } from "react-icons/io5";
import swal from "sweetalert";
import { LoadingSpinner, isUrdu } from "../../../../constants/const";
import { GetLanguageString, NoResult } from "../../../helper/Components";
import { GetCustomStyles, GetSelectedLanguage } from "../../../helper/Method";
import { ApiFinance } from "../ApiFinance";
import AddFinanceCategory from "./AddFinanceCategory";
import EditFinanceCategory from "./EditFinanceCategory";
import UpdateFinanceSubCategories from "./UpdateFinanceAccountCategories";

const FinanceCategories = ({ activeTab }) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [financeCategories, setFinanceCategories] = useState([]);
  const [
    selectedFinanceAccountCategories,
    setSelectedFinanceAccountCategories,
  ] = useState([]);
  const [financeCategoryId, setFinanceCategoryId] = useState([]);
  const [updateModal, setUpdateModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [reload, setReload] = useState(false);
  const [editValues, setEditValues] = useState();

  useEffect(() => {
    if (activeTab === "financeCategories") {
      setLoading(true);
      ApiFinance()
        .GetFinanceCategoriesList()
        .then((res) => {
          setFinanceCategories(res.data);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
  }, [activeTab, reload]);

  const handleOnDelete = (value) => {
    swal({
      title: t("common_delete_message"),
      text: t("common_delete_detail_message"),
      icon: "warning",
      buttons: true,
      className: GetSelectedLanguage() === "en" ? "" : "ur",
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setLoading(true);
        ApiFinance()
          .DeleteFinanceCategory(value)
          .then((res) => {
            // swal({
            //   title: t("finance_finance_category_deleted"),
            //   className: GetSelectedLanguage() === "en" ? "" : "ur",
            //   icon: "success",
            //   buttons: "OK",
            // });
            setReload(!reload);
            setLoading(false);
          })
          .catch((err) => {
            console.log(err);
            swal({
              title: err,
              icon: "error",
              buttons: "OK",
            });
            setLoading(false);
          });
      }
    });
  };

  const handleOnEdit = (e) => {
    setEditValues(e);
    setEditModal(true);
  };

  const handleOnUpdate = (e) => {
    setFinanceCategoryId(e.id);
    setSelectedFinanceAccountCategories(e.subCategories);
    setUpdateModal(true);
  };

  return (
    <div>
      {updateModal ? (
        <UpdateFinanceSubCategories
          setUpdateModal={setUpdateModal}
          financeCategoryId={financeCategoryId}
          previouslySelectedFinanceAccountCategories={
            selectedFinanceAccountCategories
          }
          setReload={setReload}
          reload={reload}
        />
      ) : null}
      {editModal ? (
        <EditFinanceCategory
          categoryValues={editValues}
          setEditModal={setEditModal}
          setReload={setReload}
          reload={reload}
        />
      ) : null}
      {addModal ? (
        <AddFinanceCategory
          setAddModal={setAddModal}
          setReload={setReload}
          reload={reload}
        />
      ) : null}
      <div className="ibox ">
        <div className="ibox-title">
          <h5>
            <GetLanguageString props="finance_tab_finance_categories" />
          </h5>
          <Button
            color="white"
            size="sm"
            className={GetCustomStyles().btn_style}
            onClick={() => {
              setAddModal(true);
            }}
          >
            <IoAdd
              size={18}
              color="#18A689"
              style={{ marginRight: 3, marginBottom: 1 }}
            />
            {<GetLanguageString props="finance_tab_finance_categories_add" />}
          </Button>
        </div>
        <div className="ibox-content">
          {!loading ? (
            financeCategories.length !== 0 ? (
              <div className="table-responsive">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>
                        {<GetLanguageString props="finance_tab_category" />}
                      </th>
                      <th>{<GetLanguageString props="settings_code" />}</th>
                      <th>
                        {
                          <GetLanguageString props="finance_tab_account_categories" />
                        }
                      </th>
                      <th className="text-right">
                        {<GetLanguageString props="common_action" />}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {financeCategories.map((record, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td className={isUrdu(record.category) ? "ur" : ""}>
                            {record.category}
                          </td>
                          <td className={isUrdu(record.code) ? "ur" : ""}>
                            {record.code}
                          </td>
                          <td>
                            {record.subCategories !== null && record.subCategories.length > 0
                              ? record.subCategories.map(
                                  (record1, index1) => {
                                    return (
                                      <Badge
                                        size="xs"
                                        color="info"
                                        className="label label-info m-r-xs"
                                        key={index1}
                                      >
                                        <h5>{record1.label}</h5>
                                      </Badge>
                                    );
                                  }
                                )
                              : "-"}
                          </td>
                          <td className="text-right">
                            <ButtonGroup>
                              <Button
                                color="white"
                                size="sm"
                                onClick={() => handleOnUpdate(record)}
                              >
                                {
                                  <GetLanguageString props="finance_tab_finance_account_update_btn_categories" />
                                }
                              </Button>
                              <Button
                                color="white"
                                size="sm"
                                onClick={() => handleOnEdit(record)}
                              >
                                {<GetLanguageString props="common_edit" />}
                              </Button>
                              <Button
                                color="white"
                                size="sm"
                                onClick={() => handleOnDelete(record.id)}
                              >
                                {<GetLanguageString props="common_delete" />}
                              </Button>
                            </ButtonGroup>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            ) : (
              <NoResult />
            )
          ) : (
            LoadingSpinner()
          )}
        </div>
      </div>
    </div>
  );
};

export default FinanceCategories;
